<template>
  <div class="videoList">
    <SectionTitleBar :sectionLinks="availableViews" />
    <template v-if="selectedView == 'unreviewed'">
      <table class="adminUserTable" >
        <thead>
          <tr>
            <th v-for="field in fields" :key="field.key">{{field.label}}</th>
          </tr>
        </thead>
        <tbody>
          <FirebaseRow v-for="ad in unreviewedAds" :record="ad" :fields="fields" :key="ad.id" :collection="'fb_ads'"/>
        </tbody>
      </table>
    </template>
    <template v-if="selectedView == 'linked'">
      <table class="adminUserTable" >
        <thead>
          <tr>
            <th v-for="field in fields" :key="field.key">{{field.label}}</th>
          </tr>
        </thead>
        <tbody>
          <FirebaseRow v-for="ad in linkedAds" :record="ad" :fields="fields" :key="ad.id" :collection="'fb_ads'"/>
        </tbody>
      </table>
    </template>
  </div>
</template>

<script>
import FirebaseRow from '../components/FirebaseRow.vue'
import SectionTitleBar from '../components/SectionTitleBar.vue'

export default {
  name: 'ads',
  components: {
    SectionTitleBar,
    FirebaseRow,
  },
  data () {
    return {
      selectedView: "unreviewed",
      showFilter: true,
      viewLinks: {
        "unreviewed": {
          "name": "Unreviewed Ads",
          "admin": true,
        },
        "linked": {
          "name": "Linked Ads",
          "admin": true,
        }
      }
    }
  },
  created: function(){
    this.$store.dispatch("fetchAds")
    if (this.$route.query.view && this.selectedView != this.$route.query.view) {
      this.selectedView = this.$route.query.view
    }
  },
  beforeRouteUpdate (to, from, next) {
    if (to.query.view && this.selectedView != to.query.view) {
      this.selectedView = to.query.view
    }
    next()
  },
  computed: {
    unreviewedAds(){
      return this.$store.getters.getUnarchivedAds.filter((ad)=>{
        return (!ad.deliverable)
      });
    },
    linkedAds(){
      return this.$store.getters.getUnarchivedAds.filter((ad)=>{
        return (ad.deliverable)
      });
    },
    availableViews(){
      var visibleViews = []
      var existingRoute = this.$route
      var selectedView = this.selectedView
      var viewLinks = this.viewLinks
      Object.keys(this.viewLinks).forEach((linkKey) => {
        if (!viewLinks[linkKey].admin || this.$store.getters.isAdmin) {
          var linkRoute = {
            ...existingRoute,
            query: {
              ...existingRoute.query,
              view: linkKey
            }
          }
          visibleViews.push({
            ...viewLinks[linkKey],
            route: linkRoute,
            selected: (selectedView === linkKey)
          })
        }
      })
      return visibleViews
    },
    fields () {
      return [
        {
          "label": "Name",
          "key": "name",
          "type": "String",
          "editable": false
        },
        {
          "label": "Deliverable",
          "key": "deliverable",
          "type": "Reference",
          "editable": true
        },
        {
          "label": "Status",
          "key": "status",
          "type": "String",
          "editable": false
        },
        {
          "label": "Effective Status",
          "key": "effective_status",
          "type": "String",
          "editable": false
        },
        {
          "label": "Preview Link",
          "key": "preview_shareable_link",
          "type": "URL",
          "editable": false
        },
        {
          "label": "Archived",
          "key": "archived",
          "type": "Boolean",
          "editable": true
        },
        {
          "label": "Last Updated",
          "key": "updated_time",
          "type": "Date",
          "editable": false
        }
      ]
    }
  }
}
</script>

<style>
  .videoList {
    width: 100%;
  }
  .groupName {
    text-align: center;
  }
  .videoList {
    width: 100%;
    height: 100%;
  }
  .adminUserTable {
    width: 100%;
    text-align: left;
    border-collapse: collapse;
  }
  td {
    border: 2px solid #2E303A;
  }
  td, th {
    padding: 15px;
  }
</style>
